import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/arbitroEstadisticas`;

const readResponse = async (response, fallbackMessage) => {
  if (response.ok) return response.json();
  const body = await response.json().catch(() => ({}));
  const error = new Error(body.message || fallbackMessage);
  error.status = response.status;
  throw error;
};

export const buscarArbitros = async (nombre, navigate, idCompeticion = "", idTemporada = "") => {
  let url = `${API_URL}/search?q=${encodeURIComponent(String(nombre || "").trim())}`;
  if (idCompeticion) url += `&idCompeticion=${encodeURIComponent(idCompeticion)}`;
  if (idTemporada) url += `&idTemporada=${encodeURIComponent(idTemporada)}`;
  const response = await fetchWithAuth(url, { method: "GET" }, navigate);
  return readResponse(response, "No se pudo buscar árbitros.");
};

export const getEstadisticasArbitro = async (idArbitro, navigate, idCompeticion = "", idTemporada = "") => {
  let url = `${API_URL}/${encodeURIComponent(idArbitro)}`;
  if (idCompeticion) url += `?idCompeticion=${encodeURIComponent(idCompeticion)}`;
  if (idTemporada) url += `${idCompeticion ? "&" : "?"}idTemporada=${encodeURIComponent(idTemporada)}`;
  const response = await fetchWithAuth(url, { method: "GET" }, navigate);
  return readResponse(response, "No se pudieron cargar las estadísticas del árbitro.");
};

export const getRankingArbitros = async (navigate, idCompeticion = "", idTemporada = "") => {
  let url = `${API_URL}/ranking`;
  if (idCompeticion) url += `?idCompeticion=${encodeURIComponent(idCompeticion)}`;
  if (idTemporada) url += `${idCompeticion ? "&" : "?"}idTemporada=${encodeURIComponent(idTemporada)}`;
  const response = await fetchWithAuth(url, { method: "GET" }, navigate);
  return readResponse(response, "No se pudo cargar el ranking de árbitros.");
};

export const getEstadisticasArbitralesCompeticion = async (navigate, idCompeticion, idTemporada) => {
  const params = new URLSearchParams({ idCompeticion, idTemporada });
  const response = await fetchWithAuth(`${API_URL}/competicion?${params}`, { method: "GET" }, navigate);
  if (response.status === 404) return null;
  return readResponse(response, "No se pudieron cargar las estadísticas arbitrales de la competición.");
};

export const getCompeticionesArbitros = async (navigate) => {
  const response = await fetchWithAuth(
    `${API_URL}/competiciones`,
    { method: "GET" },
    navigate
  );
  return readResponse(response, "No se pudieron cargar las competiciones.");
};
